import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Scans from "@/pages/Scans";
import Handoffs from "@/pages/Handoffs";
import OutreachHistory from "@/pages/OutreachHistory";
import Buyers from "@/pages/Buyers";
import DocsVault from "@/pages/DocsVault";
import Workshop from "@/pages/Workshop";
import Settings from "@/pages/Settings";
import "@/App.css";

const RequireAuth = ({ children }) => {
  const t = localStorage.getItem("jr_token");
  return t ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors closeButton />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="/scans" element={<RequireAuth><Scans /></RequireAuth>} />
        <Route path="/handoffs" element={<RequireAuth><Handoffs /></RequireAuth>} />
        <Route path="/outreach" element={<RequireAuth><OutreachHistory /></RequireAuth>} />
        <Route path="/buyers" element={<RequireAuth><Buyers /></RequireAuth>} />
        <Route path="/vault" element={<RequireAuth><DocsVault /></RequireAuth>} />
        <Route path="/workshop" element={<RequireAuth><Workshop /></RequireAuth>} />
        <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
